const InitialsScrapBalanceIcon = () => {
	return (
		<svg height="24" width="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300.16 300.16" >
			<g>
				<g>
					<path d="M250.023,48.414h11.406V24.207h-96.826h-3.776c2.319-2.576,3.776-5.95,3.776-9.683
			c0.001-8.007-6.516-14.523-14.523-14.523s-14.524,6.516-14.524,14.524c0,3.733,1.457,7.107,3.776,9.683h-3.776H38.73v24.206
			h11.406l-49.7,109.345l8.811,4.004l44.007-96.806l44.007,96.811l8.811-4.004l-49.7-109.35h79.184v211.525
			c-5.258,2.508-9.876,6.303-13.28,11.174H82.302c-13.347,0-24.206,10.859-24.206,24.206v4.841h183.969v-4.841
			c0-13.347-10.859-24.206-24.206-24.206h-39.974c-3.403-4.87-8.022-8.666-13.28-11.174V48.414h79.184l-49.701,109.345l8.811,4.004
			l44.007-96.806l44.007,96.811l8.811-4.004L250.023,48.414z M150.08,9.684c2.668,0,4.841,2.174,4.841,4.841
			s-2.174,4.841-4.841,4.841c-2.668,0-4.841-2.174-4.841-4.841S147.412,9.684,150.08,9.684z M48.413,38.731V33.89h87.143v4.841
			H48.413z M171.038,278.38l1.399,2.416h45.421c6.313,0,11.697,4.047,13.696,9.683H68.606c1.999-5.635,7.383-9.683,13.696-9.683
			h45.421l1.399-2.416c4.318-7.47,12.35-12.108,20.958-12.108C158.688,266.271,166.719,270.909,171.038,278.38z M150.08,256.589
			c-1.636,0-3.249,0.155-4.841,0.387V33.89h9.683v223.086C153.328,256.744,151.716,256.589,150.08,256.589z M164.604,33.89h87.143
			v4.841h-87.143V33.89z"/>
					<path d="M82.302,183.969H24.206C10.859,183.969,0,173.111,0,159.762v-4.841h106.508v4.841
			C106.508,173.111,95.649,183.969,82.302,183.969z"/>
					<path d="M275.953,183.969h-58.095c-13.347,0-24.206-10.859-24.206-24.206v-4.841H300.16v4.841
			C300.16,173.111,289.301,183.969,275.953,183.969z"/>
				</g>
			</g>
		</svg>
	);
}

export default InitialsScrapBalanceIcon;